<div
  class="read-word-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <div class="read-word-word-dialog">
    <!-- ! Errors -->
    <div *ngIf="_deletedField">
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="30px" [options]="options"></ng-lottie>
        </div>
        <div *ngIf="_deleteFromDDC">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been deleted.</div>
        <div *ngIf="_deleteFromDic">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been removed from dictionary.</div>
      </div>
    </div>
    <!-- Header -->
    <div class="word-type-priv" *ngIf="!_deletedField">
      <ddc-text-gradient
        class="text-2xl"
        [_icon]="'fiber_manual_record'"
        [_text]="'Word'"
        [_type]="'1'"
      ></ddc-text-gradient>
      <!-- ! Privacy -->
      <ddc-privacy [code]="_selectedPrivacyChipOptions" [withText]="false"></ddc-privacy>
    </div>
    <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
    <!-- ! Word Container -->
    <div class="add-dialog-container" *ngIf="!_deletedField">
      <div class="alert alert-danger" *ngIf="_editError">
        {{ _editError }}
      </div>
      <div *ngIf="_editedField">
        <div class="alert alert-success success-msg">
          <div>
            <ng-lottie width="30px" [options]="options"></ng-lottie>
          </div>
          <div>&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been edited.</div>
        </div>
      </div>
      <div class="add-dialog-row-1 add-dialog-lng">
        <ddc-country-flag [ddc_lng]="_selectedLanguage" [has_label]="true"></ddc-country-flag>
      </div>
      <div class="word-dialog-row">
        <div class="word-art" *ngIf="_selectedArticle" matTooltip="Article">{{ _selectedArticle }}</div>
        <div class="word-word">{{ _selectedWord }}</div>
        <div class="word-pos" *ngIf="_selectedPos" matTooltip="Part of Speech">{{ _selectedPos }}</div>
      </div>
      <div class="word-cat-tag">
        <div class="word-cat" *ngIf="_selectedCategory?.length ? _selectedCategory[0] : null">
          <ddc-category-s *ngIf="_selectedCategory[0]" [label]="_selectedCategory[0].label"></ddc-category-s>
        </div>
        <ddc-tag-s
          class="word-tag"
          *ngIf="_selectedTags?.length ? _selectedTags : []"
          [tags]="_selectedTags | slice: 0 : 3"
        ></ddc-tag-s>
      </div>
      <ddc-definition [text]="_selectedDefinition"></ddc-definition>
      <ddc-example [text]="_selectedExample"></ddc-example>
      <ddc-dics [elements]="_selectedDics?.length ? _selectedDics : []"></ddc-dics>
    </div>

    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px; margin-top: 20px"></mat-divider>
    <div class="read-word-dialog-submit-container">
      <div class="read-word-dialog-submit-container-right">
        <!-- Cancel -->
        <button class="read-word-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Close</button>
      </div>
      <div class="read-word-dialog-submit-container-left"></div>
    </div>
  </div>
</div>
